import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]
  static values = {
    interval: { type: String, default: "month" }
  }

  connect() {
    const urlInterval = this.intervalFromUrl()
    if (this.validInterval(urlInterval)) {
      this.intervalValue = urlInterval
    }
    this.sync()
  }

  select(event) {
    this.intervalValue = event.currentTarget.dataset.interval
    this.persist()
    this.sync()
  }

  sync() {
    this.buttonTargets.forEach((button) => {
      const selected = button.dataset.interval === this.intervalValue
      button.setAttribute("aria-pressed", selected ? "true" : "false")
      button.classList.toggle("bg-gray-900", selected)
      button.classList.toggle("text-white", selected)
      button.classList.toggle("text-gray-700", !selected)
    })

    this.panelTargets.forEach((panel) => {
      const selected = panel.dataset.interval === this.intervalValue
      panel.classList.toggle("hidden", !selected)
      panel.setAttribute("aria-hidden", selected ? "false" : "true")
    })
  }

  persist() {
    const url = new URL(window.location.href)
    url.searchParams.set("billing_interval", this.intervalValue)
    window.history.replaceState(window.history.state, "", url)
  }

  intervalFromUrl() {
    return new URL(window.location.href).searchParams.get("billing_interval")
  }

  validInterval(value) {
    return value === "month" || value === "year"
  }
}
